import React from "react";
import { Outlet } from "react-router-dom";

import styled from "styled-components";

import Drawer from "../Drawer";
import { SetupHeader } from "../Headers";

const SetupLayoutStyle = styled.main`
  background: #fafafa;
  min-height: 100vh;
`;

export const SetupLayout = () => {
  return (
    <SetupLayoutStyle>
      <div className="md:hidden">
        <Drawer />
      </div>
      <SetupHeader />
      <Outlet />
    </SetupLayoutStyle>
  );
};
